/**
 * @file ActionSheet
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import ActionSheet from './index.vue'

const ActionSheetConstructor = Vue.extend(ActionSheet)
let instance = new ActionSheetConstructor().$mount()

/**
 * ActionSheet
 * @param {Object} params - 参数对象
 * @param {String} params.title - 标题
 * @param {Array} params.options - 操作选项
 * @param {Object} params.colors - 自定义主题色，优先级最高，可覆盖默认主题色与 SlugUI.config.colors 设置的主题色
 */
export default function ActionSheetInstance({ title = '', options, colors }) {
    return new Promise((resolve, reject) => {
        instance.title = title.toString()
        instance.options = options
        instance.colors = colors
        instance.resolve = resolve
        instance.reject = reject
        instance.show = true
        document.body.appendChild(instance.$el)
    })
}